import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { PhcData } from 'src/app/models/interfaces/portfolio-health-check-data';
import { LoggerService } from '../logger/logger.service';
import { LoggerCode } from '../../models/logger';
import { mocker } from 'src/app/mocks/mocker';
import { ChannelBrokerService } from '../channel-broker/channel-broker.service';

const EMPTY_PHC_DATA = {
  diversifiedLevel: null,
  diversifiedLevelText: null,
  isEligible: null,
  portfolioFactors: null,
  hasZeroBalanceAccounts: false,
} as PhcData;

@Injectable({
  providedIn: 'root',
})
export class PortfolioHealthCheckService {
  isLoading = new BehaviorSubject<boolean>(true);
  private showPWHeader = new BehaviorSubject(true);
  private isFailure = new BehaviorSubject(false);
  private chartDataPayload = new BehaviorSubject<PhcData>(EMPTY_PHC_DATA);

  constructor(
    private loggerService: LoggerService,
    private cbService: ChannelBrokerService
  ) {
    this.cbService.getisEligible().subscribe(async isEligible => {
      if (!isEligible) return;
      await this.getPhcData();
    });
  }

  async getPhcData() {
    if (mocker.isMocked) {
      return mocker.mockedGetPhcData(this.isLoading, this.isFailure, this.chartDataPayload);
    }
    this.isLoading.next(true);
    this.isFailure.next(false);

    this.cbService.userGoals$.subscribe(async response => {
      try {
        const startTime = new Date().getTime();
        const data: PhcData = response;

        this.isLoading.next(false);
        this.isFailure.next(false);
        this.chartDataPayload.next(data);
        const endTime = new Date().getTime();
        const totalTime = endTime - startTime;
        this.loggerService.info(
          {
            message:
              'Time taken to get total response time and display PHC chart Data: ' +
              totalTime +
              ' milliseconds.',
          },
          LoggerCode.CHART_DATA_RESPONSE_TIME,
        );
      } catch (error) {
        this.isLoading.next(false);
        this.isFailure.next(true);
        this.loggerService.logChartDataError(error);
        this.chartDataPayload.error(error);
      }
    });
  }

  getLoading(): Observable<boolean> {
    return this.isLoading.asObservable();
  }

  getFailure(): Observable<boolean> {
    return this.isFailure.asObservable();
  }

  setFailure(value: boolean) {
    return this.isFailure.next(value);
  }

  setLoading(value: boolean) {
    return this.isLoading.next(value);
  }

  setShowPWHeader(value: boolean) {
    return this.showPWHeader.next(value);
  }

  getShowPWHeader(): Observable<boolean> {
    return this.showPWHeader.asObservable();
  }

  getDataPayload(): Observable<PhcData> {
    return this.chartDataPayload.asObservable();
  }
}
